var a={loader:"styles_loader__74hkh"};export{a as default};
